"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var detailsAccordion = document.querySelector(".details-accordion");
  if (detailsAccordion) {
    var accordionContainers = document.querySelectorAll('.details-accordion__accordion-container');
    accordionContainers.forEach(function (container) {
      // If the container has the 'active' class, set the maxHeight for the content
      if (container.classList.contains('active')) {
        var content = container.querySelector('.details-accordion__accordion-content');
        if (content) {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      }
    });
    var accordionTrigger = document.querySelectorAll('.details-accordion__accordion-heading');
    accordionTrigger.forEach(function (item) {
      item.addEventListener('click', function () {
        var container = this.closest('.details-accordion__accordion-container');
        container.classList.toggle('active');
        var content = this.nextElementSibling;
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
  }
});